/**
 * @desc 查询新闻详情
 */
import { NewsEntity } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryNewsParameter = {
  id?: string
}

const method = 'GET'
const url = '/content/operation/news'

export const queryNewsApi = (
  params?: QueryNewsParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<NewsEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryNewsApi.method = method
queryNewsApi.url = url
